import ReactEChartsCore from 'echarts-for-react/lib/core';
import { breakpointsMediaQuery, getColor, useMediaQuery } from '@/helpers/utils';
import merge from 'lodash.merge';
import { forwardRef, useCallback } from 'react';
import {
  createShouldSetEchartOption,
  useTooltipHide,
} from '@/hooks/useTooltipHide';
import type { EChartsOption } from 'echarts';
import type { CSSProperties } from 'react';

const getOption = (isMdUp: boolean): EChartsOption => ({
  color: getColor('primary'),
  tooltip: {
    triggerOn: isMdUp ? 'mousemove' : 'click',
    trigger: 'item',
    axisPointer: {
      type: 'none',
    },
    padding: [7, 10],
    backgroundColor: getColor('gray-100'),
    borderColor: getColor('gray-100'),
    textStyle: { color: getColor('gray-1100') },
    borderWidth: 1,
    transitionDuration: 0,
  },
  xAxis: {
    type: 'category',
    show: false,
    boundaryGap: false,
  },
  yAxis: {
    show: false,
    type: 'value',
    boundaryGap: false,
  },
  series: [
    {
      type: 'bar',
      symbol: 'none',
    },
  ],
  grid: { right: '0', left: '0', bottom: '0', top: '0' },
});

interface BasicEChartsProps {
  echarts: object;
  options?: EChartsOption;
  style?: CSSProperties;
  className?: string;
}

const BasicECharts = forwardRef<ReactEChartsCore, BasicEChartsProps>(
  ({ echarts, options, ...rest }, ref) => {
    const isMdUp = useMediaQuery(breakpointsMediaQuery.md);
    useTooltipHide(ref);
    const shouldSetOption = useCallback(createShouldSetEchartOption(ref), [ref]);

    return (
      <ReactEChartsCore
        ref={ref}
        echarts={echarts}
        option={merge(getOption(isMdUp), options)}
        shouldSetOption={shouldSetOption}
        {...rest}
      />
    );
  },
);

BasicECharts.displayName = 'BasicECharts';

export default BasicECharts;
